import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Button, Menu, Dropdown, message } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import filter from 'lodash/filter';
import Table from './TableStyle';
import { DEVICES, BOXES } from 'api';
import useFetch from 'utils/fetch/useFetch';
import Box from '../../StoragePage/components/BoxSetting';
import ModalUser from '../../Customers/components/ModalInfo';
import { ReactComponent as OnlineIcon } from '../../../images/online.svg';
import { ReactComponent as OfflineIcon } from '../../../images/offline.svg';
import { ReactComponent as ErrorSyncIcon } from '../../../images/sync_err_icon.svg';
import { ReactComponent as SyncIcon } from '../../../images/sync_ssucces.svg';
import { ReactComponent as OldVersionIcon } from '../../../images/old_version_icon.svg';
import { ReactComponent as NewVersionIcon } from '../../../images/new_version.svg';
import request from 'utils/request';

function List({
  data,
  getData,
  firmware,
  boxes,
  getBoxes,
  users,
  updateBox,
  updateDeviceFetch,
  limit,
  updateUsers,
  getUsers,
}) {
  const { t } = useTranslation();
  const [dataCol, setdataCol] = useState([]);
  const [userVisible, setUserVisible] = useState(false);
  const [user, setUser] = useState(null);
  const [visibleBox, setVisibleBox] = useState(false);
  const [box, setBox] = useState(null);
  const updateDevice = async (id) => {
    try {
      await request(`v1${DEVICES}/${id}/update`, { method: 'post' });
      message.success(t('udpateDeviceSuccess'));
    } catch (e) {
      console.log(e);
    }
  };
  const openBoxModal = (box, telemetry) => {
    setBox({ ...box, device: { ...box.device, telemetry } });
    setVisibleBox(!visibleBox);
  };
  const {
    data: boxesForUsers = [],
    getData: getBoxesForUser,
    loading: boxLoading,
  } = useFetch(BOXES, {
    uniqId: 'boxesForUser',
    autoFetch: false,
  });

  useEffect(() => {
    const dataForTable = map(data, (item, index) => {
      return {
        key: index,
        state: item.online ? (
          <span className="text-green flex items-center">
            {' '}
            <OnlineIcon className="mr-10" /> <span>Online</span>{' '}
          </span>
        ) : (
          <span className="text-red flex items-center">
            <OfflineIcon className="mr-10" />{' '}
            <span className="flex flex-col">
              <span>Offline </span>
              <span className="text-graytext">
                {' '}
                {item.last_online_at ? (
                  <>
                    {' '}
                    {t('with')} {moment(item.last_online_at).format('DD:MM:YY')}{' '}
                    {moment(item.last_online_at).format('hh:mm')}{' '}
                  </>
                ) : null}
              </span>
            </span>{' '}
          </span>
        ),
        mac: <span className="uppercase pr-40">{item.serial}</span>,
        status: item.synchronized ? (
          <span className="flex items-center">
            <SyncIcon className="mr-10" />
            {t('sync')}
          </span>
        ) : (
          <span className="flex items-center">
            <ErrorSyncIcon className="mr-10" />
            {t('erroSync')}
          </span>
        ),
        type: (
          <span className="flex items-center">
            Fooo door
          </span>
        ),
        firmware: (
          <span className="flex items-center">
            {item.outdated ? (
              <OldVersionIcon className="mr-10" />
            ) : (
              <NewVersionIcon className="mr-10" />
            )}
            {item.telemetry.version}
          </span>
        ),
        storage: item.box ? (
          <span> {item.box.section.warehouse.name} </span>
        ) : null,
        section: item.box ? item.box.section.name : null,
        binding: item.box ? (
          <span
            className="cursor-pointer"
            onClick={() => {
              openBoxModal(item.box, item.telemetry);
            }}
          >
            <span className="text-green uppercase"> {t('attached')}</span>{' '}
            <span className="text-black">{item.box.name}</span>
          </span>
        ) : (
          <span className="text-red uppercase">{t('dontAttached')}</span>
        ),
        firmware_button: (
          <div>
              <Dropdown
                overlay={
                  <Menu>
                  {item.outdated ? (
                    <Menu.Item key="0">
                      <a
                        onClick={() => {
                          updateDevice(item.id);
                        }}
                      >
                        {t('updateFirware') + ' ' + firmware}
                      </a>
                    </Menu.Item>
                  ) : null}
                  </Menu>
                }
                trigger={['click']}
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <EllipsisOutlined className="border-1 border-1 p-2 rounded-xs border-gray" />
                </a>
              </Dropdown>
          </div>
        ),
        // logs: (
        //   <PopoweWrapper>
        //     <Popover
        //       getPopupContainer={(triggerNode) => triggerNode.parentNode}
        //       placement="topRight"
        //       content={
        //         <div className="flex items-center">
        //           <div className="mr-19">20.05.2020 20:58</div>
        //           <div className="text-primary mr-10">{t('download')}</div>
        //           <DownIcon className="mr-22" />
        //           <div className="text-primary mr-18">{t('toForm')}</div>
        //         </div>
        //       }
        //       title="Title"
        //     >
        //       <LogIcon />
        //     </Popover>
        //   </PopoweWrapper>
        // ),
      };
    });
    setdataCol(dataForTable);
  }, [data]);

  useEffect(() => {
    if (box) {
      const sorted = filter(boxes, (item) => {
        return item.id === box.id;
      });
      setBox({
        ...sorted[0],
        device: { ...sorted[0].device, telemetry: sorted[0].device.telemetry },
      });
    }
  }, [boxes]);

  const columns = [
    {
      title: t('state'),
      dataIndex: 'state',
      key: 'state',
      render: (text, record) => {
        return <div className="item-row">{record.state}</div>;
      },
      width: '14%',
    },
    {
      title: t('mac'),
      dataIndex: 'mac',
      key: 'mac',
      render: (text, record) => {
        return <div className="item-row">{record.mac}</div>;
      },
      width: '20%',
    },
    {
      title: t('status'),
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return <div className="item-row">{record.status}</div>;
      },
      width: '20%',
    },
    {
      title: t('firmware'),
      dataIndex: 'firmware',
      key: 'firmware',
      render: (text, record) => {
        return <div className="item-row">{record.firmware}</div>;
      },
      width: '14%',
    },
    {
      title: t('storage'),
      dataIndex: 'storage',
      key: 'storage',
      render: (text, record) => {
        return <div className="item-row">{record.storage}</div>;
      },
    },
    {
      title: t('section'),
      dataIndex: 'section',
      key: 'section',
      render: (text, record) => {
        return <div className="item-row">{record.section}</div>;
      },
    },
    {
      title: t('binding'),
      dataIndex: 'binding',
      key: 'binding',
      render: (text, record) => {
        return <div className="item-row">{record.binding}</div>;
      },
    },
    {
      title: '',
      dataIndex: 'logs',
      key: 'logs',
      render: (text, record) => {
        return <div className="item-row">{record.logs}</div>;
      },
    },
    {
      title: '',
      dataIndex: 'firmware_button',
      key: 'firmware_button',
      render: (text, record) => {
        return <div className="item-row">{record.firmware_button}</div>;
      },
    },
  ];
  
  useEffect(() => {
    if (user) {
      const newData = filter(users, (item) => {
        return item.id === user.id;
      });
      setUser(newData[0]);
    }
    
  }, [users])

  return (
    <>
      <Table
        className="w-full"
        // pagination={true}
        columns={columns}
        dataSource={dataCol}
        pagination={{ pageSize: 20}}
      />
      {box ? (
        <Box
          source="devices"
          data={box}
          setBox={setBox}
          boxes={boxes}
          getBoxes={getBoxes}
          visible={visibleBox}
          setVisible={setVisibleBox}
          allUsers={users}
          updateBox={updateBox}
          updateDevice={updateDeviceFetch}
          getDevices={getData}
          limit={limit}
          setUser={setUser}
          setUserVisible={setUserVisible}
          userVisible={userVisible}
        />
      ) : null}
      {!box && userVisible && user ? (
        <ModalUser
          setUser={setUser}
          loadingBox={boxLoading}
          boxes={boxesForUsers}
          getBoxes={getBoxesForUser}
          updateData={updateUsers}
          user={user}
          users={users}
          getUsers={getUsers}
          visible={userVisible}
          setVisible={setUserVisible}
          updateDevice={updateDevice}
          updateBox={updateBox}
          locks={data}
          getDevices={getData}
          // postBox={postBox}
          setBox={setBox}
          // setVisibleAdd={setVisible}
          // visibleAdd={visible}
          setVisibleBox={setVisibleBox}
          visibleBox={visibleBox}
        />
      ) : null}
    </>
  );
}

List.propTypes = {};

export default List;
